import React, { Component } from "react";

class AccesoSimultaneoItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: this.props.message,
            value: this.props.value
        }
    }

    onHandleValueChange(event) {
        let descripcion = this.state.descripcion;
        let value = event.target.value;

        this.props.plataformaValueChange({ descripcion: descripcion, value: value });

        this.setState({ value: value });
    }

    render() {
        return (

            <div className="row">
                <br></br>
                <div className="col-xs-2">
                    <label className="word-break-all" >{this.state.descripcion}</label>
                </div>
                <div className="col-xs-2">
                    <input type="text" onChange={(event) => this.onHandleValueChange(event)}
                        className="form-control default-input"
                        value={this.state.value}
                        maxLength="1" />
                </div>
            </div>
        );
    }
}

export default AccesoSimultaneoItem;